import { AllSubKeysMessageResource } from '@/i18n/messages';
import { LucideIcon } from 'lucide-react';

export interface CustomerNavBar {
    id?: String;
    name?: string;
    langResource?: string;
    href?: string;
    icon?: LucideIcon;
    children?: CustomerNavBar[];
    type?: 'group' | 'item'; // 'group' = chỉ là header label
    groupIcon?: LucideIcon; // icon của group header
    /**
     * Số lượng hiển thị dạng badge bên cạnh label menu (ví dụ: số khảo sát chưa làm).
     * Chỉ hiển thị khi sidebar đang mở và giá trị > 0.
     */
    badge?: number;
}

export const PROCEDURE_FIELDS_PARAM_KEY = 'p-fields';

/** Tên query param dùng để lọc loại thủ tục */
export const PROCEDURE_TYPE_PARAM_KEY = 'p-types';

/**
 * Giá trị `p-types` đặc biệt cho mục "Tất cả" ở chế độ `personalized` khi
 * user đã đăng nhập NHƯNG không khớp eligibility của bất kỳ loại thủ tục nào.
 *
 * Ý nghĩa: chỉ lấy thủ tục DÙNG CHUNG — tức `Types_Token` rỗng (không gắn
 * loại đối tượng nào). KHÁC với "Tất cả" của public mode (xóa hẳn `p-types`
 * = không lọc theo loại = lấy MỌI thủ tục).
 */
export const PROCEDURE_TYPE_ALL_VALUE = 'all';
